export const GET_REPORT_CONFIG_LIST = 'GET_REPORT_CONFIG_LIST';
export const SET_REPORT_CONFIG_LIST = 'SET_REPORT_CONFIG_LIST';
export const DELETE_REPORT_CONFIG = 'DELETE_REPORT_CONFIG';
export const SAVE_REPORT_CONFIG = 'SAVE_REPORT_CONFIG';
